module.exports = __webpack_public_path__ + "static/m_how_it_works_multilayers_art@2x-0b0047dc70f20ad023dd406f557292ef.png";